import React from 'react';
import s from './AiAssistantBar.module.scss';
import { cls } from '../../utils/helpers/classNames';

/**
 * Minimal visual strip for the background AI assistant.
 * - Shows current state / transcript
 * - Offers an optional on-screen PTT button (press & hold)
 */
const AiAssistantBar = ({ ui, startPtt, stopPtt }) => {
  const mode = ui?.mode || 'idle';
  const isListening = mode === 'listening';
  const isProcessing = mode === 'processing';
  const isSpeaking = mode === 'speaking';

  const text = isListening ? (ui?.transcript || ui?.text || '') : (ui?.text || '');

  const disabled = isProcessing || isSpeaking;

  const onMouseDown = () => {
    if (typeof startPtt === 'function') startPtt();
  };
  const onMouseUp = () => {
    if (typeof stopPtt === 'function') stopPtt();
  };

  return (
    <div className={cls(s.assistantBar, { [s.listening]: isListening, [s.processing]: isProcessing, [s.speaking]: isSpeaking })}>
      <div className={s.text}>
        <span className={s.label}>AI</span>
        <span className={s.message}>{text}</span>
      </div>

      <button
        type="button"
        className={cls(s.pttBtn, { [s.pttActive]: isListening, [s.pttDisabled]: disabled })}
        onMouseDown={onMouseDown}
        onMouseUp={onMouseUp}
        onMouseLeave={onMouseUp}
        onTouchStart={(e) => {
          e.preventDefault();
          onMouseDown();
        }}
        onTouchEnd={(e) => {
          e.preventDefault();
          onMouseUp();
        }}
        aria-label="PTT (F8)"
        disabled={false}
      >
        <span className={s.pttText}>{isListening ? 'Говори' : 'F8'}</span>
      </button>
    </div>
  );
};

export default AiAssistantBar;
